import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { claimAccount } from '../API';

const ClaimAccount = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    email: searchParams.get('email') || '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    if (formData.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }

    setLoading(true);

    try {
      const response = await claimAccount({
        email: formData.email,
        password: formData.password,
      });
      setSuccess(response.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-4">
      <div className="container-fluid col-sm-8 col-lg-6">
        <div className="jumbotron mt-2">
          <h1 className="display-4">Activer votre compte</h1>

          {success ? (
            <>
              <div className="alert alert-success" role="alert">
                {success}
              </div>
              <p className="mb-0">
                Utilisez votre courriel pour vous connecter une fois l'activation terminée.
              </p>
            </>
          ) : (
            <>
              <p className="lead">
                Si vous vous connectiez auparavant avec Google, entrez le courriel associé à
                ce compte et choisissez un mot de passe. Un courriel de vérification vous
                sera envoyé pour confirmer l'activation.
              </p>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Courriel (compte Google)</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Mot de passe</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    minLength={8}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    minLength={8}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Envoi...' : 'Envoyer le courriel de vérification'}
                </button>
              </form>
            </>
          )}

          <p className="mt-3 mb-0">
            Déjà activé? <Link to="/login">Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClaimAccount;
